import { render, staticRenderFns } from "./OrderProducts.vue?vue&type=template&id=65aa40fa&"
import script from "./OrderProducts.vue?vue&type=script&lang=js&"
export * from "./OrderProducts.vue?vue&type=script&lang=js&"
import style0 from "./OrderProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports